
























import UsersList from "@/components/admin/users/UsersListForm.vue";
import { Vue, Component } from "vue-property-decorator";
import { Preset as IPreset } from "@/api-v2/learning-requests/models/preset";
import { learningRequestApi } from "@/getinfo-api";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({
  components: { CustomButton, CField, CSingleSelect, UsersList }
})
export default class UsersListView extends Vue {
  presetList: IPreset[] = [];
  title: string = "";
  preset: string = "";
  isLoading: boolean = false;

  get currentCompany() {
    return getCurrentCompanyId();
  }
  async create() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    this.isLoading = true;
    learningRequestApi.StatusProfiles.profilePreset({
      companyId: this.currentCompany,
      id: this.preset,
      title: this.title
    })
      .then(() => {
        this.$store.dispatch("successToast", {
          message: `${this.$tc(this.$translate.Successful)}`
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
  created() {
    learningRequestApi.StatusProfiles.profilesPresetsList().then(res => {
      this.presetList = res.data;
    });
  }
}
